{
	"name": "@lucidcms/core",
	"version": "0.10.2-alpha.0",
	"description": "The core of the Lucid CMS. It's responsible for spinning up the API and serving the CMS.",
	"type": "module",
	"types": "./dist/index.d.ts",
	"module": "dist/index.js",
	"exports": {
		".": {
			"import": "./dist/index.js",
			"types": "./dist/index.d.ts"
		},
		"./adapters": {
			"types": "./dist/adapters.d.ts",
			"default": "./dist/adapters.js"
		},
		"./api": {
			"types": "./dist/api.d.ts",
			"default": "./dist/api.js"
		},
		"./builders": {
			"types": "./dist/builders.d.ts",
			"default": "./dist/builders.js"
		},
		"./middleware": {
			"types": "./dist/middleware.d.ts",
			"default": "./dist/middleware.js"
		},
		"./types": {
			"types": "./dist/types.d.ts",
			"default": "./dist/types.js"
		},
		"./package.json": "./package.json"
	},
	"scripts": {
		"build": "tsc && tsup",
		"dev": "tsup --watch",
		"format": "biome format ./src",
		"format:fix": "biome format --write ./src",
		"lint": "biome lint ./src",
		"lint:fix": "biome lint --apply ./src",
		"clear-db:postgres": "node ./scripts/clear-db-pg.js"
	},
	"files": ["dist", "cms", "templates", "assets"],
	"author": "Proto Digital",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/ProtoDigitalUK/lucid_cms.git",
		"directory": "packages/core"
	},
	"keywords": [
		"CMS",
		"Headless",
		"Node.js",
		"Typescript",
		"ESM",
		"Fastify",
		"Postgres",
		"SQLite",
		"LibSQL",
		"Kysely"
	],
	"devDependencies": {
		"@biomejs/biome": "^1.8.3",
		"@lucidcms/admin": "*",
		"@lucidcms/config": "*",
		"@types/fs-extra": "^11.0.4",
		"@types/jsonwebtoken": "^9.0.6",
		"@types/lodash.merge": "^4.6.9",
		"@types/mime-types": "^2.1.4",
		"@types/mjml": "^4.7.4",
		"@types/node": "^20.14.10",
		"@types/node-cron": "^3.0.11",
		"@types/pg": "^8.11.6",
		"@types/sanitize-html": "^2.11.0",
		"@types/semver": "^7.5.8",
		"@types/slug": "^5.0.9",
		"@types/uuid": "^10.0.0",
		"tsup": "^8.2.4",
		"typescript": "^5.5.4"
	},
	"dependencies": {
		"@fastify/cookie": "^9.3.1",
		"@fastify/cors": "^9.0.1",
		"@fastify/helmet": "^11.1.1",
		"@fastify/rate-limit": "^9.1.0",
		"@fastify/static": "^7.0.4",
		"@fastify/swagger": "^8.15.0",
		"@fastify/swagger-ui": "^4.1.0",
		"@libsql/kysely-libsql": "^0.4.1",
		"@tailwindcss/vite": "^4.0.0-beta.4",
		"argon2": "^0.41.1",
		"better-sqlite3": "^11.5.0",
		"blurhash": "^2.0.5",
		"date-fns": "^4.1.0",
		"fast-average-color-node": "^3.1.0",
		"fastify": "^4.28.1",
		"fastify-plugin": "^4.5.1",
		"fs-extra": "^11.2.0",
		"handlebars": "^4.7.8",
		"jsonwebtoken": "^9.0.2",
		"kysely": "^0.27.4",
		"lodash.merge": "^4.6.2",
		"mime-types": "^2.1.35",
		"mjml": "^5.0.0-alpha.4",
		"node-cron": "^3.0.3",
		"pg": "^8.13.1",
		"sanitize-html": "^2.13.1",
		"semver": "^7.6.3",
		"sharp": "^0.33.5",
		"slug": "^10.0.0",
		"solid-js": "^1.9.3",
		"tailwindcss": "^4.0.0-beta.4",
		"uuid": "^11.0.3",
		"vite": "^5.3.3",
		"vite-plugin-solid": "^2.11.0",
		"winston": "^3.17.0",
		"zod": "^3.23.8",
		"zod-validation-error": "^3.4.0",
		"@lucidcms/admin": "0.10.2-alpha.0"
	},
	"volta": {
		"node": "20.18.1"
	},
	"license": "MIT"
}
